import { render, staticRenderFns } from "./programa-contrato-goup.vue?vue&type=template&id=30ab2adc"
import script from "./programa-contrato-goup.vue?vue&type=script&lang=js"
export * from "./programa-contrato-goup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports